import { Box, Tab, Tabs } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { isTablet } from "react-device-detect";
import { useSearchParams } from "react-router-dom";
import { inIframe, isNullOrEmpty, SELLER_SITE_PATH, WEBSITE_PATH, windowPostMessage } from "../common/common";
import { CreateHeader } from "../components/headers";
import { SetStoreData } from "../components/storeCardList";
import { StoreDetailsContext } from "../contexts/entityDetailsContext";
import StoreRequestMessage from "./requestMessage";
import StoreQuotationRequests from "./storeQuotationRequests";

const StoreMessageRequest = () => {
  const [tabIndex, setTabIndex] = useState<number>(1);
  const { storeDetails, setStoreDetails } = useContext<any>(StoreDetailsContext);
  const [searchParam] = useSearchParams();
  const storecodenum: any = useRef<string>();

  //#regin useEffect
  useEffect(() => {
    if (!inIframe()) {
      window.location.href = WEBSITE_PATH;
      return;
    }
    storecodenum.current = encodeURIComponent(searchParam.get("storeId"));

    window.addEventListener("message", handleWindowMessageReceived);

    return () => {
      window.removeEventListener("message", handleWindowMessageReceived);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isNullOrEmpty(storeDetails)) {
      windowPostMessage({ type: "getstoredetails" }, WEBSITE_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeDetails]);

  //#endregion

  //#region Function calls
  const handleWindowMessageReceived = (event: any) => {
    if (event.origin && event.origin.includes(SELLER_SITE_PATH.slice(0, -1))) {
      const data = event.data;
      if (data.type === "storedetails") {
        SetStoreData(storecodenum.current, data.storeDetails, searchParam.get("sessionId"), setStoreDetails);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    let tabName = newValue === 0 ? "quotations" : "messages";
    window.history.replaceState("", "", `${window.location.origin}/store-requests?storeId=${storeDetails.scnum}&sessionId=${storeDetails.sessionID}&tab=${tabName}`);
  };
  //#endregion

  return (
    <Box className="inboxWindow flex-column pad-top-gutter">
      <CreateHeader title="Message requests" isTextBox={false} />
      <Box className={`${isTablet ? "mar-t-64" : "mar-t-56"} w-per-100`}>
        <Box className={`pad-l-r-gutter display-flex-justify-center ${isTablet ? "mar-b-24" : "mar-b-16"}`}>
          <Tabs value={tabIndex} onChange={handleChange} sx={{ display: "inline-flex !important" }}>
            <Tab label="Quotation requests" />
            <Tab label="Message requests" />
          </Tabs>
        </Box>
        <Box className={`${tabIndex === 0 ? "mdc-soft-show" : "mdc-soft-hide"}`}>
          <StoreQuotationRequests />
        </Box>
        <Box className={`${tabIndex === 1 ? "mdc-soft-show" : "mdc-soft-hide"}`}>
          <StoreRequestMessage />
        </Box>
      </Box>
    </Box>
  );
};

export default StoreMessageRequest;
